import { Injectable } from "@angular/core";

@Injectable()
export class NotificationMenuService {
  getNotifications(): object[] {
    return [];
  }
}
